import { parse, format } from '@flex-packages/utils/url';

function resource(absoluteOrRelativeURL, rawHostname = "") {
  const { pathname, ...parsed } = parse(absoluteOrRelativeURL);
  const hostname = rawHostname || process.env.NEXT_PUBLIC_STATIC_FILE_HOST;
  const resourcePath = format({
    ...parsed,
    hostname,
    protocol: "https:",
    // MIXED-CONTENT 대응을 위해 프로토콜은 HTTPS로 강제
    pathname: pathname.startsWith("/") ? pathname : `/${pathname}`
  });
  return resourcePath;
}

export { resource as default };
//# sourceMappingURL=resource.mjs.map
